var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Home---Desktop-X-Large-(1440)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 12.073A12 12 0 1 0 10.125 24v-8.437H7.078v-3.49h3.047v-2.66c0-3.026 1.792-4.7 4.533-4.7a18.345 18.345 0 0 1 2.686.236v2.974h-1.513a1.74 1.74 0 0 0-1.956 1.885v2.265H17.2l-.532 3.49h-2.8V24A12.054 12.054 0 0 0 24 12.073",
  fill: "#fff",
  fillRule: "evenodd",
  "data-name": "footer-/-desktop"
}))));
export default SvgFacebook;